import script from "./ProposalList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProposalList.vue?vue&type=script&setup=true&lang=js"

import "./ProposalList.vue?vue&type=style&index=0&id=0a55e70b&lang=css"

const __exports__ = script;

export default __exports__